module.exports = __webpack_public_path__ + "fonts/fa-brands-400.cff6d3b9.eot";